module.exports = __webpack_public_path__ + "img/ic_huawei_logo_normal.ddd165d.png";